interface RuntimeConfig {
  VITE_API_URL?: string;
  VITE_APP_ENV?: string;
}

const runtimeConfig = (window as unknown as { __CONFIG__?: RuntimeConfig }).__CONFIG__ ?? {};

export const env = {
  apiUrl:  runtimeConfig.VITE_API_URL  ?? import.meta.env['VITE_API_URL'] as string,
  isDev:   import.meta.env.DEV,
} as const;
